module.exports = __webpack_public_path__ + "static/media/portfolio1 (63).e7ae2009.jpeg";